/**
 * 亲友角色默认属性
 */
import type { FamilyRole, Openness, InfluenceLevel, FocusType } from '../types/family';

export interface FamilyRoleDefaults {
  role: FamilyRole;
  label: string;
  emoji: string;
  defaultOpenness: Openness;
  defaultInfluence: InfluenceLevel;
  defaultFocus: FocusType;
  description: string;
  defaultPersonality: string;
  defaultJob: string;
}

export const FAMILY_ROLE_DEFAULTS: FamilyRoleDefaults[] = [
  {
    role: '母亲',
    label: '母亲',
    emoji: '👩',
    defaultOpenness: '保守',
    defaultInfluence: '高',
    defaultFocus: '条件',
    description: '细致挑剔、重视人品',
    defaultPersonality: '细心、嘴硬心软、护犊子、爱旁敲侧击',
    defaultJob: '退休教师',
  },
  {
    role: '父亲',
    label: '父亲',
    emoji: '👨',
    defaultOpenness: '中立',
    defaultInfluence: '高',
    defaultFocus: '条件',
    description: '理性务实、看重条件',
    defaultPersonality: '沉稳、务实、话不多',
    defaultJob: '企业中层',
  },
  {
    role: '闺蜜',
    label: '闺蜜',
    emoji: '👯‍♀️',
    defaultOpenness: '开放',
    defaultInfluence: '中',
    defaultFocus: '感觉',
    description: '感性支持、看感觉',
    defaultPersonality: '热情、八卦、仗义',
    defaultJob: '自由职业',
  },
  {
    role: '兄弟',
    label: '兄弟',
    emoji: '👬',
    defaultOpenness: '开放',
    defaultInfluence: '中',
    defaultFocus: '感觉',
    description: '大大咧咧、看颜值',
    defaultPersonality: '豪爽、直率、大大咧咧',
    defaultJob: '销售',
  },
  {
    role: '七大姑',
    label: '七大姑',
    emoji: '🧑‍🦱',
    defaultOpenness: '保守',
    defaultInfluence: '低',
    defaultFocus: '细节',
    description: '八卦多事、问题多',
    defaultPersonality: '八卦、热心、爱管闲事',
    defaultJob: '居委会主任',
  },
  {
    role: '八大姨',
    label: '八大姨',
    emoji: '🧓',
    defaultOpenness: '保守',
    defaultInfluence: '低',
    defaultFocus: '细节',
    description: '传统观念、催婚急',
    defaultPersonality: '传统、催婚、爱比较',
    defaultJob: '退休工人',
  },
];

/** 根据角色类型获取默认属性 */
export function getFamilyRoleDefaults(role: FamilyRole): FamilyRoleDefaults {
  const defaults = FAMILY_ROLE_DEFAULTS.find(d => d.role === role);
  if (!defaults) throw new Error(`Unknown family role: ${role}`);
  return defaults;
}
